<template>
    <label class="custom-radio">
        <input type="checkbox" class="custom-control-input" :checked="isSelected" :disabled="disabled" @change="change"/>
        <span
            class="d-flex custom-control-indicator align-items-center justify-content-center"
            :class="{disabled: disabled}"
            :style="color ? { '--custom-radio-color': color } : null">
            <span v-if="checkIcon && !hasIconSlot" class="custom-radio-text e3-no-select" :class="{'d-none': !isSelected}">
                {{ icon }}
            </span>
            <slot
                v-else-if="hasIconSlot"
                name="icon"
                :size="18"
                :icon-class="{'text-white': true, 'd-none': !isSelected}"/>
            <component
                :is="radioIcon"
                v-else
                class="text-white"
                :class="{'d-none': checkIcon || !isSelected}"
                :size="18"/>
        </span>
    </label>
</template>

<script>
import CheckIcon from '@/common/components/svg-icons/CheckIcon.vue';
import getSvgIconFromClass from '@/common/components/svg-icons/helpers/getSvgIconFromClass';

export default {
    name: 'CustomRadio',
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        realValue: {
            type: [String, Number, Boolean],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: null
        }
    },
    computed: {
        // TODO: Vue 3 replace $scopedSlots with $slots
        hasIconSlot() {
            return !!this.$scopedSlots.icon;
        },
        checkIcon() {
            return this.icon && this.icon.length <= 2;
        },
        radioIcon() {
            return this.icon ? getSvgIconFromClass(this.icon) : CheckIcon;
        },
        isSelected() {
            return this.realValue !== null && this.value === this.realValue;
        }
    },
    methods: {
        change($event) {
            this.$emit('input', $event.target.checked ? this.realValue : null);
        }
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.custom-radio-text {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
}

.custom-radio {
    margin-bottom: 0;
    position: relative;
    display: block;
    .custom-control-input {
        display: none;
    }
    > input[type="checkbox"] {
        & + .custom-control-indicator {
            display: block;
            position: relative;
            width: 28px;
            height: 28px;
            margin-left: auto;
            margin-right: auto;
            border: 2px solid $border-color;
            background-color: #fff;
            border-radius: 50%;
            transition: all 0.1s ease-in;
        }
        &:disabled {
            + .custom-control-indicator {
                opacity: 0.15;
                cursor: default;
            }
        }
        &:checked {
            + .custom-control-indicator {
                background: var(--custom-radio-color, #{$success});
                border-color: var(--custom-radio-color, #{$success});
                transition: all 0.2s ease-in;
            }
        }
    }
}
</style>
